import { HomeOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";

const SomethingWentWrong = () => {
  return (
    <Result
      status="500"
      title="500"
      subTitle="Sorry, something went wrong."
      extra={
        navigator.onLine ? (
          <Button icon={<HomeOutlined />} type="primary" href="/">
            Back Home
          </Button>
        ) : (
          <Button icon={<HomeOutlined />} type="primary" onClick={()=>window.location.reload(false)}>
            Reload
          </Button>
        )
      }
    />
  );
};

export default SomethingWentWrong;
